import React, { lazy, Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes as RouteConfig,
  Navigate,
} from "react-router-dom";
import Dashboard from "./pages/Home/Dashboard/Dashboard";
import Main from "./pages/Main";
import DisputeRequest from "./pages/Home/DisputeRequest/DisputeRequest";
import Profile from "./pages/Home/Profile/Profile";
import Notification from "./pages/Home/Notification/Notification";
import { Loader } from "./component/Loader";
import ViewUser from "./pages/Home/User/ViewUser";
import PostList from "./pages/Home/Posts/PostList";
import PostView from "./pages/Home/Posts/PostView";
import HashtagList from "./pages/Home/Hashtag/HashtagList";
import HashtagView from "./pages/Home/Hashtag/HashtagView";
import UserList from "./pages/Home/User/UserList";
import Cmspage from "./pages/Home/Cmspage/Cmspage";
import CmsEditor from "./pages/Home/Cmspage/CmsEditor";
import Contactus from "./pages/Home/Contactus/Contactus";
import ReportList from "./pages/Home/Reports/ReportList";
import { useAppSelector } from "./redux/reduxHook";

const Login = lazy(() => import("./pages/Auth/Login"));

const Routes: React.FC = () => {
  const { isLoggedIn } = useAppSelector((state) => state.auth);
  // const isLoggedIn = false

  // Add a loading state to ensure isLoggedIn is fully determined
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    // Simulate an async check for auth state (e.g., fetching from localStorage or an API)
    // In real code, you should check and set isLoggedIn properly here
    if (isLoggedIn !== undefined) {
      setLoading(false);
    }
  }, [isLoggedIn]);

  if (loading) {
    return <Loader />;
  }

  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <RouteConfig>
          <Route
            path="/login"
            element={isLoggedIn ? <Navigate to="/" /> : <Login />}
          />

          <Route
            path="/"
            element={isLoggedIn ? <Main /> : <Navigate to="/login" />}
          // element={<Main />}
          >
            <Route index={true} element={<Dashboard />} />
            <Route path="user-list" >
              <Route index={true} element={<UserList />} />
              <Route path=":action/:id" element={<ViewUser />} />
            </Route>
            <Route path="post-list" >
              <Route index={true} element={<PostList />} />
              <Route path=":action/:id" element={<PostView />} />
            </Route>
            <Route path="hashtag-list" >
              <Route index={true} element={<HashtagList />} />
              <Route path=":id" element={<HashtagView />} />
            </Route>
            <Route path="dispute-request" element={<DisputeRequest />} />
            <Route path="profile" element={<Profile />} />

            <Route path="cms-page" >
              <Route index={true} element={<Cmspage />} />
              <Route path="cms-editor/:type" element={<CmsEditor />} />
            </Route>

            <Route path="notification" element={<Notification />} />
            <Route path="contact-us" element={<Contactus />} />
            <Route path="report-list" element={<ReportList />} />
            {/* <Route path="service-request" element={<RequestService />} /> */}
          </Route>
        </RouteConfig>
      </Suspense>
    </Router >
  );
};

export default Routes;
